import React, { useState, useCallback } from 'react'
import Modal from 'react-modal'
import StudentSelect from './student-select'
import Reflections from './reflections'

const className = {
  base: 'full-modal',
  afterOpen: 'modal-after-open',
  beforeClose: 'modal-before-close',
}

const overlayClassName = {
  base: 'overlay',
  afterOpen: 'overlay-after-open',
  beforeClose: 'overlay-before-close',
}

const ViewReflections = ({
  isOpen,
  project,
  selectedStudent,
  setSelectedStudent,
  onClose,
}) => {
  const [searchText, setSearchText] = useState('')

  const handleClose = useCallback(
    (e) => {
      e && e.preventDefault()
      window.viewReflectionsBackAction = null
      setSelectedStudent(null)
      onClose()
    },
    [onClose, setSelectedStudent]
  )

  const handleBack = useCallback(
    (e) => {
      e.preventDefault()
      let backAction = window.viewReflectionsBackAction
      window.viewReflectionsBackAction
        ? window.viewReflectionsBackAction()
        : setSelectedStudent(null)
      window.viewReflectionsBackAction = null
      if (backAction) {
        setTimeout(() => {
          handleClose()
        }, 500)
      }
    },
    [handleClose, setSelectedStudent]
  )

  const showStudents = useCallback(
    (e) => {
      e.preventDefault()
      window.viewReflectionsBackAction = null
      setSelectedStudent(null)
    },
    [setSelectedStudent]
  )

  const showClose = useCallback(() => {
    return selectedStudent ? { display: 'none' } : {}
  }, [selectedStudent])

  return (
    <Modal
      isOpen={isOpen}
      className={className}
      contentLabel="View Reflections Modal"
      overlayClassName={overlayClassName}
    >
      <header className="full-modal-header">
        <a href="/" className="logo">
          <img src="/images/logo.png" className="logo" alt="" />
        </a>
        <h2>Reflections - {project && project.name}</h2>
        <nav role="navigation" aria-label="App Navigation">
          <a href="#" style={showClose()} onClick={handleClose}>
            Close
            <i className="material-icons">close</i>
          </a>
        </nav>
      </header>
      <section className="full-modal-body">
        {selectedStudent ? (
          <Reflections
            project={project}
            student={selectedStudent}
            searchText={searchText}
            setSearchText={setSearchText}
            showStudents={showStudents}
            onBack={handleBack}
          />
        ) : (
          project && (
            <StudentSelect project={project} onSelect={setSelectedStudent} />
          )
        )}
      </section>
    </Modal>
  )
}

export default ViewReflections
